import React from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Carolina Muñoz',
    role: 'Balcón en Bogotá',
    text: 'Nunca pensé que en mi balcón de 2x1 podría sacar tanta acelga. El manual me explicó exactamente cómo aprovechar la luz.',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=100&h=100'
  }, {
    name: 'Jorge Hernández',
    role: 'Patio en Santiago',
    text: 'Lo que más me sirvió fue la parte de plagas. Siempre se me morían los tomates, ahora tengo para regalar.',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=100&h=100'
  }, {
    name: 'Silvia Ramírez',
    role: 'Jubilada, Medellín',
    text: 'Es muy fácil de leer. No tiene palabras raras y los dibujos ayudan mucho. Ya estoy preparando mi tercera siembra.',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=100&h=100'
  }, {
    name: 'Pablo García',
    role: 'Emprendedor, CDMX',
    text: 'El bonus de emprendimiento me abrió la mente. Empecé vendiendo plantines a los vecinos y ya recuperé la inversión.',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=100&h=100'
  }, {
    name: 'Valentina S.',
    role: 'Principiante, Guadalajara',
    text: 'Tenía miedo de matar todo como siempre. Pero el sistema paso a paso te da mucha seguridad. ¡Recomendadísimo!',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=100&h=100'
  }];
  return <section className="py-20 px-4 bg-black border-t border-zinc-900" data-id="element-182">
      <div className="max-w-7xl mx-auto" data-id="element-183">
        <h2 className="text-3xl font-bold text-white text-center mb-12" data-id="element-184">
          Ellos ya están cosechando
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-185">
          {testimonials.map((t, i) => <div key={i} className="bg-zinc-900 p-6 rounded-xl border border-zinc-800 relative" data-id="element-186">
              <Quote className="absolute top-4 right-4 w-8 h-8 text-zinc-800" data-id="element-187" />
              <div className="flex gap-1 text-yellow-500 mb-4" data-id="element-188">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-current" data-id="element-189" />)}
              </div>
              <p className="text-zinc-300 mb-6 relative z-10" data-id="element-190">"{t.text}"</p>
              <div className="flex items-center gap-3" data-id="element-191">
                <img src={t.image} alt={t.name} className="w-10 h-10 rounded-full object-cover" data-id="element-192" />
                <div data-id="element-193">
                  <div className="font-bold text-white text-sm" data-id="element-194">{t.name}</div>
                  <div className="text-green-500 text-xs" data-id="element-195">{t.role}</div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}